// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <div class="info info--deposit">
    <div class="info-detail">
      <span class="key">Account number:</span>
      <span class="value">{{\$ctrl.account.productNumber}}
        </span>
    </div>
  </div>

  <h2 class="section-header">Edit collector and officer</h2>

  <form name="\$ctrl.form">

    <table class="misc-transaction__table table table--generate-row-ids">
      <tbody class="tbody">
      <tr>
        <td></td>
        <td>Collector</td>
        <td>
          <user-select
            hide-role="true"
            empty-option="true"
            ng-model="\$ctrl.account.collectorId"
            ng-change="\$ctrl.updateCenters()"
            users="\$ctrl.collectors">
          </user-select>
        </td>
      </tr>
      <tr>
        <td></td>
        <td>Officer</td>
        <td>
          <user-select
            hide-role="true"
            empty-option="true"
            ng-model="\$ctrl.account.officerId"
            ng-change="\$ctrl.updateCenters()"
            users="\$ctrl.officers">
          </user-select>
        </td>
      </tr>
      <tr ng-if="\$ctrl.availableCenters.length !== 0">
        <td></td>
        <td>Center:</td>
        <td>
          <selectize options="\$ctrl.availableCenters"
                     config="\$ctrl.centerConfig"
                     ng-model="\$ctrl.account.centerId">
          </selectize>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="clearfix"></div>

    <div class="buttons">
      <button
        class="btn btn-warning"
        ng-click="\$ctrl.redirectBack()">
        Cancel
      </button>
      <button
        class="btn btn-primary"
        ng-click="\$ctrl.update()"
        ng-disabled="\$ctrl.form.\$invalid">
        Update
      </button>
    </div>
  </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/edit-collector/edit-collector.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;